import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { PendingConfirmation } from '../agent-conversation.model';

@Component({
  selector: 'app-agent-confirmation',
  templateUrl: './agent-confirmation.component.html',
  styleUrls: ['./agent-confirmation.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentConfirmationComponent {
  readonly confirmation = input.required<PendingConfirmation>();
  readonly approve = output<void>();
  readonly deny = output<void>();
}
